import { z } from "zod";
import { DateRegex } from "./DateWithoutTime";

export const DateStringSchema = z.string().refine((val) => DateRegex.exec(val), {
  message: "Must have the format yyyy-MM-dd",
});

export type DateString = z.infer<typeof DateStringSchema>;

export function isDateString(val: unknown): val is DateString {
  return DateStringSchema.safeParse(val).success;
}
